import React from 'react';
import { TrainingShell } from '../components/TrainingV2';

const VanguardCertification: React.FC = () => {
  return (
    <TrainingShell
      moduleId="eunify-vanguard-certification"
      moduleName="E-Unify Vanguard Certification"
      backUrl="/learn101"
    />
  );
};

export default VanguardCertification;
